// extracted by mini-css-extract-plugin
export default {"rowActive":"DraggableRow__rowActive___wSdHS","lastRowActive":"DraggableRow__lastRowActive___zE_Em"};